import axios from 'axios';
import isTokenExpired from './checkTokenExpiration';

const BASE_URL = process.env.REACT_APP_BACKEND_URL;

// Helper functions to manage viewed pages in sessionStorage
const getViewedPages = () => {
  const storedPages = sessionStorage.getItem('viewedPages');
  return storedPages ? JSON.parse(storedPages) : [];
};

const addViewedPage = (pageKey) => {
  const viewedPages = getViewedPages();
  if (!viewedPages.includes(pageKey)) {
    viewedPages.push(pageKey);
    sessionStorage.setItem('viewedPages', JSON.stringify(viewedPages));
  }
};

const hasViewedPage = (pageKey) => {
  const viewedPages = getViewedPages();
  return viewedPages.includes(pageKey);
};

export const trackEvent = async (userID, eventName, featureName, metadata = {}) => {
  try {
    // Ensure userID is available
    if (!userID) {
      console.warn('Skipping event tracking: No userID provided');
      return;
    }

    const sessionID = localStorage.getItem('sessionId');
    const authToken = localStorage.getItem('authToken');

    // Verify authToken is available
    if (!authToken || isTokenExpired()) {
      console.warn('Skipping event tracking: No authentication token available');
      return;
    }

    // Check if this is a page view event and if we've already tracked this page
    if (eventName === 'Page View' && metadata.path) {
      const pageKey = `${sessionID}-${metadata.path}`;
      if (hasViewedPage(pageKey)) {
        // console.log(`Skipping duplicate page view tracking for: ${metadata.path}`);
        return;
      }
      // Mark this page as viewed for this session
      addViewedPage(pageKey);
    }

    // Convert metadata object to string for proper comparison in backend
    // This matches how the backend will need to compare it
    const payload = {
      userID,
      sessionID,
      event_name: eventName,
      feature_name: featureName || null, // Handle null feature name explicitly
      metadata: metadata || null
    };

    const response = await axios.post(
      `${BASE_URL}/api/auth/event/create`,
      payload,
      {
        headers: { 
          Authorization: `Bearer ${authToken}`
        }
      }
    );
    
    console.log(`Event tracked: ${eventName}`);
    console.log(`Response:`, response.data);
    return response;
  } catch (error) {
    console.error(`Error tracking event: ${eventName}`, error);
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.error('Response data:', error.response.data);
    }
  }
}
